import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FnUtilService, FnToasterService } from 'foundation';
import { PosHttpService } from '../../../services/pos.http.service';
import { EOCommentDetail } from '../../../modal/entity.modal';

@Component({
  selector: 'app-dashboard-comment-model',
  templateUrl: './dashboard-comment-model.component.html',
  styleUrl: './dashboard-comment-model.component.scss',
  encapsulation:ViewEncapsulation.None
})
export class DashboardCommentModelComponent {

  isSendTelegram: boolean = false;
  isSelected: boolean = false;
  commentArr: EOCommentDetail[] = [];
  commentObject: { textComment: string } = { textComment: '' };

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: HwDialogData,
    private dialogRef: MatDialogRef<DashboardCommentModelComponent>,
    private fnutilservice: FnUtilService,
    private toaster: FnToasterService,
    private posHttpSvcs: PosHttpService
  ) { }

  ngOnInit(): void {
    this.loadComments();
  }

  loadComments(): void {
    this.posHttpSvcs.authPost('v1/ui/getEOCommentArray', 'getEOCommentArray', this.dialogData.comments.primaryKey).subscribe((resp: { isError: string; data: EOCommentDetail[]; }) => {
      if (resp.isError) {
        this.toaster.error("EOCommentArray is not loaded");
      }
      this.commentArr = resp.data;
    });
  }

  addCommentAndSendToTelegram(): void {
    if (this.fnutilservice.isEmptyObject(this.commentObject.textComment)) {
      this.toaster.error('Please add comment here...');
      return
    }
    const pktData = {
      commentText: this.commentObject.textComment,
      isSendTelegram: this.isSendTelegram,
      pk: this.dialogData.comments.primaryKey
    };
    this.posHttpSvcs.authPost('v1/ui/saveComment', 'saveComment', pktData).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error(resp.data.commentText);
        return;
      } else {
        this.toaster.success("Comment added successfully");
        this.commentArr.push(resp.data);
        this.dialogData.comments.recentComment = resp.data.commentText;
        this.dialogData.comments.lastActionAt = resp.data.commentedAt;
        this.commentObject.textComment = '';
        if (this.isSendTelegram) {
          this.sendtoTelegram(resp.data.commentedBy);
        }
      }
    }));

    this.close();
  }

  sendtoTelegram(user: string): void {
    let msg = `Action: Comment Added \n`;

    const filteredComments = this.commentArr.map(comment => {
      return comment;
    });
    if (filteredComments.length === 0) {
      msg += `Action By : ${user}\n`;
      msg += `Action At : ${this.dialogData.comments.lastActionAt}\n`;
      msg += `Comment : ${this.dialogData.comments.recentComment}\n`;
    } else if (filteredComments.length >= 1) {
      const lastComment = filteredComments[filteredComments.length - 2];  
      msg += `Action By : ${user}\n`;
      msg += `Action At : ${this.dialogData.comments.lastActionAt}\n`;
      msg += `Comment: ${this.dialogData.comments.recentComment}\n\n`;
      msg += `Last Action By : ${lastComment.commentedBy}\n`;
      msg += `Last Action At : ${lastComment.commentedAt}\n`;
      msg += `Last Comment : ${lastComment.commentText}\n`;
    }
    const pktData = {
      msg: msg,
      pk: this.dialogData.comments.primaryKey
    };
    this.posHttpSvcs.authPost('v1/ui/generateTelegram', 'generateTelegram', pktData).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error("Telegram Msg not sent");
        return;
      }
    }));

  }

  close() {
    this.dialogRef.close();
  }

  selectionCheck(event: any): void {
    this.isSelected = event.target.checked;
  }

}

interface HwDialogData {
  comments: any;
}

